import React from 'react';
import ghana from '../../../../../assets/img/icons/country/ghana.png';
import useExpiredCustomers from '../../../../../hooks/shared/customers/useExpiredCustomers';

const ExpiredGhana90days = () => {
  const {
    state: { ghanaExpired90 },
  } = useExpiredCustomers();

  return (
    <div className="col-lg col-md col-sm">
      <div className="boxes">
        <div className="text-center">
          <div className="text-center mt-3">
            <img src={ghana} alt="Ghana" width="40px" height="30px" />
          </div>
          <div className="count">{ghanaExpired90}</div>
          <h3 className="color-two">Ghana Expired in 90 days</h3>
        </div>
      </div>
    </div>
  );
};

export default ExpiredGhana90days;
